import { render, staticRenderFns } from "./FooterApp.vue?vue&type=template&id=97cacfcc&scoped=true&"
import script from "./FooterApp.vue?vue&type=script&lang=js&"
export * from "./FooterApp.vue?vue&type=script&lang=js&"
import style0 from "./FooterApp.vue?vue&type=style&index=0&id=97cacfcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cacfcc",
  null
  
)

export default component.exports